"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchFieldWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _button = require("../../controls/buttons/button.tokens");
var _input = require("../input/input.tokens");
var _globalTokens = require("../../../shared/global-tokens");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _Button = require("../../controls/buttons/Button");
var getBackgroundColor = function getBackgroundColor(props, hover) {
  if (props.isDisabled) {
    return (0, _button.buttonTokens)(props.theme).color.background[props.emphasis].disabled;
  } else if (hover) {
    return props.showInputField ? (0, _button.buttonTokens)(props.theme).color.background[props.emphasis].default : (0, _button.buttonTokens)(props.theme).color.background[props.emphasis].hover;
  } else {
    return (0, _button.buttonTokens)(props.theme).color.background[props.emphasis].default;
  }
};
var getColor = function getColor(props, hover) {
  if (props.isDisabled) {
    return (0, _button.buttonTokens)(props.theme).color.icon[props.emphasis].disabled;
  } else if (hover) {
    return props.showInputField ? (0, _button.buttonTokens)(props.theme).color.icon[props.emphasis].default : (0, _button.buttonTokens)(props.theme).color.icon[props.emphasis].hover;
  } else {
    return (0, _button.buttonTokens)(props.theme).color.icon[props.emphasis].default;
  }
};
var getBorderColor = function getBorderColor(props, hover) {
  if (props.isDisabled) {
    return (0, _button.buttonTokens)(props.theme).border[props.emphasis].disabled;
  } else if (hover) {
    return props.showInputField ? (0, _button.buttonTokens)(props.theme).border[_Button.EMPHASIS.MEDIUM].default : (0, _button.buttonTokens)(props.theme).border[props.emphasis].hover;
  } else {
    return props.showInputField ? (0, _button.buttonTokens)(props.theme).border[_Button.EMPHASIS.MEDIUM].default : (0, _button.buttonTokens)(props.theme).border[props.emphasis].default;
  }
};
var SearchFieldWrapper = exports.SearchFieldWrapper = _styledComponents.default.div.withConfig({
  displayName: "SearchFieldstyled__SearchFieldWrapper",
  componentId: "sc-1rg8k7h-0"
})(["display:flex;align-items:center;background-color:", ";border:", ";border-radius:", ";height:", ";margin:2px 0;&:hover{background-color:", ";border:", ";svg{path{fill:", ";}}}svg{path{fill:", ";}}input{flex:1;color:", ";", ";width:", ";padding:0;padding-left:", ";}&:has(.focus-ring),&:has(:focus){background-color:", ";color:", ";outline:2px solid ", ";outline-offset:-2px;svg{path{fill:", ";}}}input,button{-webkit-appearance:none;border:none;outline:none;background:none;}input::-webkit-search-cancel-button,input::-webkit-search-decoration{-webkit-appearance:none;}"], function (props) {
  return getBackgroundColor(props, false);
}, function (props) {
  return getBorderColor(props, false);
}, _globalTokens.globalBorder.radius['3'], function (props) {
  return _input.tokens.size.height[props.size];
}, function (props) {
  return getBackgroundColor(props, true);
}, function (props) {
  return getBorderColor(props, true);
}, function (props) {
  return getColor(props, true);
}, function (props) {
  return getColor(props, false);
}, function (props) {
  return getColor(props, false);
}, _tokens.default.sky.sys.font.body['1'], function (props) {
  return props.showInputField ? props.width : '0px';
}, function (_ref) {
  var showInputField = _ref.showInputField;
  return showInputField ? _globalTokens.globalSpacing['200'] : '0px';
}, function (props) {
  return (0, _button.buttonTokens)(props.theme).color.background[props.emphasis].focus;
}, function (props) {
  return (0, _button.buttonTokens)(props.theme).color.font[props.emphasis].focus;
}, function (props) {
  return props.theme.sys.color.border.focusring;
}, function (props) {
  return (0, _button.buttonTokens)(props.theme).color.icon[props.emphasis].focus;
});